"use strict";
// This is not yet a complete store for lab-related state, but it can
// be used to hold lab-specific information that is not available in any
// other existing redux store.  It also holds useful state for newer labs
// that use LabContainer.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValidationState = exports.clearPageError = exports.setPageError = exports.setIsLoading = exports.shouldHideShareAndRemix = exports.hasPageError = exports.isReadOnlyWorkspace = exports.isLabLoading = exports.setUpWithoutLevel = exports.setUpWithLevel = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var types_1 = require("./types");
var Lab2Registry_1 = __importDefault(require("./Lab2Registry"));
var ProjectManagerFactory_1 = __importDefault(require("./projects/ProjectManagerFactory"));
var projectRedux_1 = require("../code-studio/projectRedux");
var HttpClient_1 = __importStar(require("../util/HttpClient"));
var ProgressManager_1 = require("./progress/ProgressManager");
var responseValidators_1 = require("./responseValidators");
var initialState = {
    isLoadingProjectOrLevel: false,
    isLoading: false,
    pageError: undefined,
    channel: undefined,
    initialSources: undefined,
    validationState: (0, ProgressManager_1.getInitialValidationState)(),
    levelProperties: undefined,
};
// Thunks
// Set up the lab properties and project manager for the given level (and optional script),
// then load the project and store the channel and source in redux.
// If we are given a channel id, we will use that to load the project, otherwise we will
// get the channel id based on the level and script id.
// If we get an aborted signal, we will exit early.
exports.setUpWithLevel = (0, toolkit_1.createAsyncThunk)('lab/setUpWithLevel', function (payload, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var levelProperties, isProjectLevel, disableProjects, projectManager, _a, _b, sources, channel, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 7, , 8]);
                // Update properties for reporting as early as possible in case of errors.
                Lab2Registry_1.default.getInstance().getMetricsReporter().updateProperties({
                    currentLevelId: payload.levelId,
                    scriptId: payload.scriptId,
                    channelId: payload.channelId,
                });
                return [4 /*yield*/, cleanUpProjectManager()];
            case 1:
                _c.sent();
                return [4 /*yield*/, loadLevelProperties(payload.levelPropertiesPath)];
            case 2:
                levelProperties = _c.sent();
                Lab2Registry_1.default.getInstance()
                    .getMetricsReporter()
                    .updateProperties({ appName: levelProperties.appName });
                isProjectLevel = levelProperties.isProjectLevel, disableProjects = levelProperties.disableProjects;
                if (disableProjects) {
                    // If projects are disabled on this level, we can skip loading projects data.
                    setProjectAndLevelData({ levelProperties: levelProperties }, thunkAPI.signal.aborted, thunkAPI.dispatch);
                    return [2 /*return*/];
                }
                if (!(payload.channelId && isProjectLevel)) return [3 /*break*/, 3];
                _a = ProjectManagerFactory_1.default.getProjectManager(types_1.ProjectManagerStorageType.REMOTE, payload.channelId);
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, ProjectManagerFactory_1.default.getProjectManagerForLevel(types_1.ProjectManagerStorageType.REMOTE, payload.levelId, payload.scriptId)];
            case 4:
                _a = _c.sent();
                _c.label = 5;
            case 5:
                projectManager = _a;
                // Only set the project manager and initiate load
                // if this request hasn't been cancelled.
                if (thunkAPI.signal.aborted) {
                    return [2 /*return*/];
                }
                // Set channel ID for reporting in case we hit an error and can't update the store.
                Lab2Registry_1.default.getInstance().getMetricsReporter().updateProperties({
                    channelId: projectManager.getChannelId(),
                });
                Lab2Registry_1.default.getInstance().setProjectManager(projectManager);
                return [4 /*yield*/, setUpAndLoadProject(projectManager, thunkAPI.dispatch)];
            case 6:
                _b = _c.sent(), sources = _b.sources, channel = _b.channel;
                setProjectAndLevelData({ initialSources: sources, channel: channel, levelProperties: levelProperties }, thunkAPI.signal.aborted, thunkAPI.dispatch);
                return [3 /*break*/, 8];
            case 7:
                error_1 = _c.sent();
                return [2 /*return*/, thunkAPI.rejectWithValue(error_1)];
            case 8: return [2 /*return*/];
        }
    });
}); });
// Given a channel id and app name as the payload, set up the lab for that channel id.
// This consists of cleaning up the existing project manager (if applicable), then
// creating a project manager and loading the project data.
// This method is used for loading a lab that is not associated with a level
// (e.g., /projectbeats).
// If we get an aborted signal, we will exit early.
exports.setUpWithoutLevel = (0, toolkit_1.createAsyncThunk)('lab/setUpWithoutLevel', function (payload, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var projectManager, _a, sources, channel, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                // Update properties for reporting as early as possible in case of errors.
                Lab2Registry_1.default.getInstance().getMetricsReporter().updateProperties({
                    channelId: payload.channelId,
                    appName: payload.appName,
                });
                return [4 /*yield*/, cleanUpProjectManager()];
            case 1:
                _b.sent();
                projectManager = ProjectManagerFactory_1.default.getProjectManager(types_1.ProjectManagerStorageType.REMOTE, payload.channelId);
                Lab2Registry_1.default.getInstance().setProjectManager(projectManager);
                return [4 /*yield*/, setUpAndLoadProject(projectManager, thunkAPI.dispatch)];
            case 2:
                _a = _b.sent(), sources = _a.sources, channel = _a.channel;
                setProjectAndLevelData({
                    initialSources: sources,
                    channel: channel,
                    levelProperties: { appName: payload.appName },
                }, thunkAPI.signal.aborted, thunkAPI.dispatch);
                return [3 /*break*/, 4];
            case 3:
                error_2 = _b.sent();
                return [2 /*return*/, thunkAPI.rejectWithValue(error_2)];
            case 4: return [2 /*return*/];
        }
    });
}); });
// Selectors
// If any load is currently in progress.
var isLabLoading = function (state) {
    return state.lab.isLoadingProjectOrLevel || state.lab.isLoading;
};
exports.isLabLoading = isLabLoading;
// This may depend on more factors, such as share.
var isReadOnlyWorkspace = function (state) {
    var _a;
    return !((_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.isOwner);
};
exports.isReadOnlyWorkspace = isReadOnlyWorkspace;
// If there is an error present on the page.
var hasPageError = function (state) {
    return state.lab.pageError !== undefined;
};
exports.hasPageError = hasPageError;
// If the share and remix buttons should be hidden for the lab. Defaults to true (hidden)
// if not specified.
var shouldHideShareAndRemix = function (state) {
    var _a;
    var hideShareAndRemix = (_a = state.lab.levelProperties) === null || _a === void 0 ? void 0 : _a.hideShareAndRemix;
    return hideShareAndRemix === undefined ? true : hideShareAndRemix;
};
exports.shouldHideShareAndRemix = shouldHideShareAndRemix;
var labSlice = (0, toolkit_1.createSlice)({
    name: 'lab',
    initialState: initialState,
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setPageError: function (state, action) {
            state.pageError = action.payload;
        },
        clearPageError: function (state) {
            state.pageError = undefined;
        },
        setChannel: function (state, action) {
            state.channel = action.payload;
        },
        setValidationState: function (state, action) {
            state.validationState = __assign({}, action.payload);
        },
        // Update the level properties, initial sources, and channel simultaneously when the level changes.
        // These fields are updated together so that labs receive all updates at once.
        onLevelChange: function (state, action) {
            state.channel = action.payload.channel;
            state.levelProperties = action.payload.levelProperties;
            state.initialSources = action.payload.initialSources;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(exports.setUpWithLevel.fulfilled, function (state) {
            state.isLoadingProjectOrLevel = false;
        });
        builder.addCase(exports.setUpWithLevel.rejected, function (state, action) {
            // If the set up was aborted, that means another load got started
            // before we finished. Therefore we only set loading to false if the
            // action was not aborted.
            if (!action.meta.aborted) {
                state.isLoadingProjectOrLevel = false;
                state.pageError = getErrorFromThunkAction(action, 'setUpWithLevel failed');
            }
        });
        builder.addCase(exports.setUpWithLevel.pending, function (state) {
            state.isLoadingProjectOrLevel = true;
        });
        builder.addCase(exports.setUpWithoutLevel.fulfilled, function (state) {
            state.isLoadingProjectOrLevel = false;
        });
        builder.addCase(exports.setUpWithoutLevel.rejected, function (state, action) {
            // If the set up was aborted, that means another load got started
            // before we finished. Therefore we only set loading to false
            // and set the page error if the action was not aborted.
            if (!action.meta.aborted) {
                state.isLoadingProjectOrLevel = false;
                state.pageError = getErrorFromThunkAction(action, 'setUpWithoutLevel failed');
            }
        });
        builder.addCase(exports.setUpWithoutLevel.pending, function (state) {
            state.isLoadingProjectOrLevel = true;
        });
    },
});
// Retrieve error details from a thunk action payload.
function getErrorFromThunkAction(action, defaultErrorMessage) {
    var errorMessage, error, details;
    if (action.meta.rejectedWithValue) {
        var payloadError = action.payload;
        errorMessage = payloadError.message;
        error = payloadError;
        // Get additional details if the error or its cause is a network error.
        var networkError = undefined;
        if (payloadError instanceof HttpClient_1.NetworkError) {
            networkError = payloadError;
        }
        else if (payloadError.cause &&
            payloadError.cause instanceof HttpClient_1.NetworkError) {
            networkError = payloadError.cause;
        }
        if (networkError) {
            details = networkError.getDetails();
        }
    }
    else {
        errorMessage = defaultErrorMessage;
        error = action.error;
    }
    return {
        errorMessage: errorMessage,
        error: error,
        details: details,
    };
}
// Helper function to add event listeners to the project manager
// and load the project. Returns the project load response.
// This should be called from a thunk, which will provide its
// thunk dispatch method.
function setUpAndLoadProject(projectManager, dispatch) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    projectManager.addSaveStartListener(function () {
                        return dispatch((0, projectRedux_1.setProjectUpdatedSaving)());
                    });
                    projectManager.addSaveSuccessListener(function (channel) {
                        dispatch((0, projectRedux_1.setProjectUpdatedAt)(channel.updatedAt));
                        dispatch(setChannel(channel));
                    });
                    projectManager.addSaveNoopListener(function (channel) {
                        if (channel) {
                            dispatch((0, projectRedux_1.setProjectUpdatedAt)(channel.updatedAt));
                            dispatch(setChannel(channel));
                        }
                        else {
                            dispatch((0, projectRedux_1.setProjectUpdatedSaved)());
                        }
                    });
                    projectManager.addSaveFailListener(function () { return dispatch((0, projectRedux_1.setProjectUpdatedError)()); });
                    return [4 /*yield*/, projectManager.load()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
// Helper function to set the channel, source, and level data in redux.
// If aborted is true, we won't set anything in redux. Once
// we are done, we will mark the lab as ready for reload.
// This should be called from a thunk, which will provide its
// thunk dispatch method.
function setProjectAndLevelData(data, aborted, dispatch) {
    // Only set channel and sources if the request has not been cancelled.
    if (aborted) {
        return;
    }
    // Dispatch level change last so labs can react to the new level data
    // and new initial sources at once.
    dispatch(onLevelChange(data));
}
function loadLevelProperties(levelPropertiesPath) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, HttpClient_1.default.fetchJson(levelPropertiesPath, {}, responseValidators_1.LevelPropertiesValidator)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.value];
            }
        });
    });
}
function cleanUpProjectManager() {
    return __awaiter(this, void 0, void 0, function () {
        var existingProjectManager;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    existingProjectManager = Lab2Registry_1.default.getInstance().getProjectManager();
                    // Save any unsaved code and clear out any remaining enqueued
                    // saves from the existing project manager.
                    return [4 /*yield*/, (existingProjectManager === null || existingProjectManager === void 0 ? void 0 : existingProjectManager.cleanUp())];
                case 1:
                    // Save any unsaved code and clear out any remaining enqueued
                    // saves from the existing project manager.
                    _a.sent();
                    Lab2Registry_1.default.getInstance().clearProjectManager();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setIsLoading = (_a = labSlice.actions, _a.setIsLoading), exports.setPageError = _a.setPageError, exports.clearPageError = _a.clearPageError, exports.setValidationState = _a.setValidationState;
// These should not be set outside of the lab slice.
var _b = labSlice.actions, setChannel = _b.setChannel, onLevelChange = _b.onLevelChange;
exports.default = labSlice.reducer;
